/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderOtherChargeRec.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-other-charge-rec";

export class AutogenModelOrderOtherChargeRec<RowType extends ModelRow> extends Endpoint<RowType, RowOrderOtherChargeRecFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderOtherChargeRec extends ModelRow<RowOrderOtherChargeRecFields> {
	constructor(values?: Partial<RowOrderOtherChargeRecFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderOtherChargeRecFields {
	amount: number;
	calc_method: string;
	charge_id: string;
	customer_id: string;
	customer_name: string;
	descr: string;
	est_fuel_surcharge: string;
	id: string;
	incl_in_freight: string;
	order_id: string;
	rate: number;
	rate_id: string;
	units: number;
}

